import React from 'react';
import { Bar, Line } from 'react-chartjs-2';
import 'chart.js/auto';
import { useEffect, useState } from 'react';
import axios from 'axios';
import apiUrl from '../../Environment/Api';
import { useNavigate } from 'react-router-dom';

function Dashboard() {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [tomorrowDate, setTomorrowDate] = useState(null);
  const [dayAfterTomorrowDate, setDayAfterTomorrowDate] = useState(null);


  useEffect(() => {
    getdata();
    getdataeditor();
    getdataproject();
    getdatapending();
    getdatadeadline();
    getdataproject1();
    getyear();
    getmonths();
    gettotalamountmonthswise();
    getinvoice();


    const tomorrow = new Date(currentDate);
    tomorrow.setDate(currentDate.getDate() + 1);

    const dayAfterTomorrow = new Date(currentDate);
    dayAfterTomorrow.setDate(currentDate.getDate() + 2);

    setTomorrowDate(tomorrow);
    setDayAfterTomorrowDate(dayAfterTomorrow);
  }, [currentDate]);
  const formatDate = (date) => {
    return date.toISOString().split('T')[0];
  };

  useEffect(() => {
    console.log('Current Date:', formatDate(currentDate));
    if (tomorrowDate) console.log('Tomorrow\'s Date:', formatDate(tomorrowDate));
    if (dayAfterTomorrowDate) console.log('Day After Tomorrow\'s Date:', formatDate(dayAfterTomorrowDate));
  }, [currentDate, tomorrowDate, dayAfterTomorrowDate]);




  // const barChartData = {
  //   labels: ['Category 1', 'Category 2', 'Category 3', 'Category 4', 'Category 5'],
  //   datasets: [
  //     {
  //       label: 'Bar Chart Data',
  //       backgroundColor: 'rgba(75,192,192,0.2)',
  //       borderColor: 'rgba(75,192,192,1)',
  //       borderWidth: 1,
  //       hoverBackgroundColor: 'rgba(75,192,192,0.4)',
  //       hoverBorderColor: 'rgba(75,192,192,1)',
  //       data: [65, 59, 80, 81, 56],
  //     },
  //   ],
  // };

  // const barChartOptions = {
  //   scales: {
  //     x: {
  //       type: 'category',
  //       position: 'bottom',
  //     },
  //     y: {
  //       beginAtZero: true,
  //     },
  //   },
  // };




  const [getDataclient, setDataclient] = useState([])
  const [totalclient, settotalclient] = useState([]);
  const getdata = async () => {
    try {
      const response = await axios.get(apiUrl + '/clientdetails');
      setDataclient(response.data);
      settotalclient(response.data.length)
    }
    catch (error) {
      console.log(error)
    }
  };




  const [totalproject1, settotalproject1] = useState([]);
  const getdataproject1 = async () => {
    try {
      const response = await axios.get(apiUrl + '/invoicelist');

      settotalproject1(response.data.length)
    }
    catch (error) {
      console.log(error)
    }
  };


  const [getDataeditor, setDataeditor] = useState([])
  const [totaleditor, settotaleditor] = useState([]);
  const getdataeditor = async () => {
    try {
      const response = await axios.get(apiUrl + '/editor');
      setDataeditor(response.data);
      settotaleditor(response.data.length)
    }
    catch (error) {
      console.log(error)
    }
  }


  const [getDataproject, setDataproject] = useState([])
  const [totalproject, settotalproject] = useState([]);
  const getdataproject = async () => {
    try {
      const response = await axios.get(apiUrl + '/task');
      setDataproject(response.data);
      settotalproject(response.data.length)
    }
    catch (error) {
      console.log(error)
    }
  }

  const [getDatapending, setDatapending] = useState([])

  const getdatapending = async () => {
    try {
      const response = await axios.get(apiUrl + '/taskpending');
      setDatapending(response.data);
      console.log(response.data)

    }
    catch (error) {
      console.log(error)
    }
  }

  const [getDatadeadline, setDatadeadline] = useState([])

  const getdatadeadline = async () => {
    try {
      const response = await axios.get(apiUrl + '/tasksByAssignDate');
      setDatapending(response.data);
      console.log(response.data)

    }
    catch (error) {
      console.log(error)
    }
  }
  const navigate = useNavigate()
  const handlenavigatecient = () => {
    navigate('/client-details')
  }
  const handlenavigateeditor = () => {
    navigate('/editors')
  }
  const handlenavigateproject = () => {
    navigate('/task-management')
  }
  const handlePasswordChange = () => {
    navigate('/passwordchange')
  }



  // to get a year for the invoicelist----------

  const [getcountyear, setcountyear] = useState([])

  const getyear = async () => {
    try {
      const response = await axios.get(apiUrl + '/invoicelistyears');
      setcountyear(response.data);
      console.log(" the console for year---------", getcountyear);

    }
    catch (error) {
      console.log(error)
    }
  }
  const [getinvoicedata, setinvoicedata] = useState([])
  const getinvoice = async () => {
    try {
      const response = await axios.get(apiUrl + '/invoicedetailsdashboard');
      setinvoicedata(response.data);
    }
    catch (error) {
      console.log(error)
    }
  }


  console.log("indian data", getinvoicedata.totalAmountByCountry)
  // console.log("other country data", totalothercountryamount)

  const [getcountmonths, setcountmonths] = useState([])

  const getmonths = async () => {
    try {
      const response = await axios.get(apiUrl + '/invoicelistmonths');
      setcountmonths(response.data);
      console.log("Fetched Data:", response.data); // Log the fetched data
    } catch (error) {
      console.log(error);
    }
  }

  const monthNames = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
  ];

  const createGradient = () => {
    const ctx = document.createElement('canvas').getContext('2d');
    const gradient = ctx.createLinearGradient(0, 0, 0, 300); // Adjust the gradient direction and size
    gradient.addColorStop(0, 'rgba(75, 192, 192, 0.6)'); // Start color with transparency
    gradient.addColorStop(1, 'rgba(75, 192, 192, 0)'); // End color with full transparency
    return gradient;
  };

  const barChartData = {
    labels: monthNames,
    datasets: [
      {
        label: 'Month-wise Count',
        backgroundColor: createGradient(), // Call the function to generate gradient
        borderColor: 'rgb(2,199,194)',
        borderWidth: 1,
        hoverBackgroundColor: 'rgba(75, 192, 192, 0.8)',
        hoverBorderColor: 'rgba(75, 192, 192, 1)',
        data: monthNames.map((monthName) => {
          const monthData = getcountmonths.find((item) => item.month === monthNames.indexOf(monthName) + 1);
          return monthData ? monthData.count : 0;
        }),
      },
    ],
  };
  const barChartOptions = {
    scales: {
      x: {
        type: 'category',
        position: 'bottom',
      },
      y: {
        beginAtZero: true,
      },
    },
  };
  const [gettotalamountmonths, settotalamountmonths] = useState([]);

  const gettotalamountmonthswise = async () => {
    try {
      const response = await axios.get(apiUrl + '/monthlytotalamount');
      settotalamountmonths(response.data);
    } catch (error) {
      console.log(error);
    }
  };


  const monthName = [ 'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

  const gettotalamountmonth = getinvoicedata.totalAmountByCountry && getinvoicedata.totalAmountByCountry["91"];
  const gettotaldollarmonth = getinvoicedata.totalAmountByCountry && getinvoicedata.totalAmountByCountry["others"];

  const lineChartConfig = {
    type: 'line',
    data: {
      labels: monthName,
      datasets: [
        {
          label: 'INR Total Income',
          backgroundColor: '#E94C5C',
          borderColor: '#E94C5C',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255, 99, 132, 0.4)',
          hoverBorderColor: 'rgba(255, 99, 132, 1)',
          data: monthName.map((monthName, index) => {
            if (gettotalamountmonth) {
              const monthData = gettotalamountmonth[index + 1];
              return monthData ? monthData || 0 : 0;
            } else {
              return 0;
            }
          }),
        },
      ],
    },
    options: {
      scales: {
        x: {
          type: 'category',
          position: 'bottom',
        },
        y: {
          beginAtZero: true,
        },
      },
    },
  };

  const lineChartConfigdollar = {
    type: 'line',
    data: {
      labels: monthName,
      datasets: [
        {
          label: 'Dollar Total Income',
          backgroundColor: 'rgb(15,89,151)',
          borderColor: 'rgb(15,89,151)',
          borderWidth: 1,
          hoverBackgroundColor: 'rgba(255, 99, 132, 0.4)',
          hoverBorderColor: 'rgba(255, 99, 132, 1)',
          data: monthName.map((monthName, index) => {
            if (gettotaldollarmonth) {
              const monthData = gettotaldollarmonth[index + 1];
              return monthData ? monthData || 0 : 0;
            } else {
              return 0;
            }
          }),
        },
      ],
    },
    options: {
      scales: {
        x: {
          type: 'category',
          position: 'bottom',
        },
        y: {
          beginAtZero: true,
        },
      },
    },
  };
  const [activeChart, setActiveChart] = useState('incomeReports');

  const handleShowIncomeReport = () => {
    setActiveChart('incomeReports');
  };

  const handleShowDollarChart = () => {
    setActiveChart('dollarChart');
  };

  return (
    <>

      <div className="d-flex">
        <h5 className="mt-2">Dashboard</h5>

      </div>
      <hr />
      <div className='row'>
        <div className='col-lg-3 col-md-6 col-sm-12 '>
          <div className='card client-card'>
            <div className='row p-3 client-row1'>
              <div className='col-lg-6 col-md-6 col-sm-6'>
                <h1 className=' text-white'><b>{totalclient}</b></h1>
                <h4 className=' text-white'>Clients</h4>
              </div>
              <div className='col-lg-6 col-md-6 col-sm-6'>
                <img className='client-icon' src={window.location.origin + require('../../../assets/img/client-dashboard-icon.png')} />
              </div>
            </div>
            <div className='row client-row2'>
              <p onClick={handlenavigatecient} className='text-center mt-2 moreinfo'>More Info<i class="fa-solid fa-circle-arrow-right mx-2"></i></p>
            </div>
          </div>
        </div>
        <div className='col-lg-3 col-md-6 col-sm-12 '>
          <div className='card client-card1'>
            <div className='row p-3 editor-row1'>
              <div className='col-lg-6 '>
                <h1 className=' text-white'><b>{totaleditor}</b></h1>
                <h4 className=' text-white'>Editors</h4>
              </div>
              <div className='col-lg-6'>
                <img className='client-icon' src={window.location.origin + require('../../../assets/img/Admin/editor-dashboard-icon.png')} />
              </div>
            </div>
            <div className='row editor-row2'>
              <p onClick={handlenavigateeditor} className='text-center mt-2 moreinfo'>More Info<i class="fa-solid fa-circle-arrow-right mx-2"></i></p>

            </div>
          </div>
        </div>
        <div className='col-lg-3 col-md-6 col-sm-12'>
          <div className='card client-card2'>
            <div className='row p-3 project-row1'>
              <div className='col-lg-6 '>
                <h1 className=' text-white'><b>{totalproject1}</b></h1>
                <h4 className=' text-white'>Project</h4>
              </div>
              <div className='col-lg-6'>
                <img className='client-icon' src={window.location.origin + require('../../../assets/img/Admin/project-dashboard-icon.png')} />
              </div>
            </div>
            <div className='row project-row2'>
              <p onClick={handlenavigateproject} className='text-center mt-2 moreinfo'>More Info<i class="fa-solid fa-circle-arrow-right mx-2"></i></p>

            </div>
          </div>
        </div>
        <div className='col-lg-3 col-md-6 col-sm-12'>
          <div className='card client-card3'>
            <div className='row p-3 user-row1'>
              <div className='col-lg-6 '>
                <h1 className=' text-white'><b>1</b></h1>
                <h4 className=' text-white'>Users</h4>
              </div>
              <div className='col-lg-6'>
                <img className='client-icon' src={window.location.origin + require('../../../assets/img/Admin/user-dashboard-icon.png')} />
              </div>
            </div>
            <div className='row user-row2'>
              <p onClick={handlePasswordChange} className='text-center mt-2 moreinfo'>More Info<i class="fa-solid fa-circle-arrow-right mx-2"></i></p>

            </div>
          </div>
        </div></div>

      {/* <div className='card main-card-dashboard p-2 '>
        <div className='row'>
        <div className='col-lg-3 col-md-3 col-sm-12'>
            <div className='card text-center dashboardcard'>
            
              <div className='row'>
                <div className='col-lg-6 col-md-3 col-sm-6 mt-3  icon-title-card'>
                <img className='client-icon' src={window.location.origin + require('../../../assets/img/client-dashboard-icon.png')} />
               
                </div>
                <div className='col-lg-6 col-md-6 col-sm-6 mt-3 '>
                  <b className='title-style list-content'>Client</b>
                  <h1 className='list-content'>{totalclient}</h1>
                  <button className='readmore-button list-content' onClick={handlenavigatecient}>Read More</button>
                </div>
              </div>
            </div>

          </div>

          <div className='col-lg-3 col-md-3 col-sm-12'>
            <div className='card text-center dashboardcard'>
             
              <div className='row'>
                <div className='col-lg-6 col-md-3 col-sm-6 mt-3  icon-title-card'>
                <img className='editor-icon' src={window.location.origin + require('../../../assets/img/Admin/editor-dashboard-icon.png')} />
               
                </div>
                <div className='col-lg-6 col-md-6 col-sm-6 mt-3 '>
                  <b className='title-style list-content'>Editor</b>
                  <h1 className='list-content'>{totaleditor}</h1>
                  <button className='readmore-button list-content' onClick={handlenavigatecient}>Read More</button>
                </div>
              </div>
            </div>

          </div>
          <div className='col-lg-3 col-md-3 col-sm-12'>
            <div className='card text-center dashboardcard'>
            
              <div className='row'>
                <div className='col-lg-6 col-md-3 col-sm-6 mt-3  icon-title-card'>
                <img className='project-icon' src={window.location.origin + require('../../../assets/img/Admin/project-dashboard-icon.png')} />
               
                </div>
                <div className='col-lg-6 col-md-6 col-sm-6 mt-3 '>
                  <b className='title-style list-content'>Project</b>
                  <h1 className='list-content'>{totalproject1}</h1>
                  <button className='readmore-button list-content' onClick={handlenavigatecient}>Read More</button>
                </div>
              </div>
            </div>

          </div>
          <div className='col-lg-3 col-md-3 col-sm-12'>
            <div className='card text-center dashboardcard'>
            
              <div className='row'>
                <div className='col-lg-6 col-md-3 col-sm-6 mt-3  icon-title-card'>
                <img className='user-icon' src={window.location.origin + require('../../../assets/img/Admin/user-dashboard-icon.png')} />
               
                </div>
                <div className='col-lg-6 col-md-6 col-sm-6 mt-3 '>
                  <b className='title-style list-content'>User</b>
                  <h1 className='list-content'>1</h1>
                  <button className='readmore-button list-content' onClick={handlenavigatecient}>Read More</button>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div> */}
      {/* <div className='row'>
        <div className='col-lg-6 col-md-6 col-sm-12'>
          <div className='card main-card-dashboard p-3'>
            <b className='text-start mb-3'>Deadline Task</b>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">#</th>
                  <th scope="col">First</th>
                  <th scope="col">Last</th>
                  <th scope="col">Handle</th>
                </tr>
              </thead>
              <tbody>
                {getDatapending.map((item, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>

                    <td className="desc">{item.editorName}</td>


                  </tr>
                ))}
              </tbody>
            </table>
          </div>


        </div>
        <div className='col-lg-6 col-md-6 col-sm-12'>
          <div className='card main-card-dashboard p-3'>
            <b className='text-start mb-3'>Pending Task</b>
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th scope="col">Client Name</th>
                  <th scope="col">Project Name</th>
                  <th scope="col">Editor</th>
                  <th scope="col">Status</th>
                </tr>
              </thead>
              <tbody>
                {getDatapending.map((item, index) => (
                  <tr key={index}>


                    <td className="desc">{item.clientName}</td>
                    <td className="desc">{item.projectName}</td>
                    <td className="desc">{item.editorName}</td>
                    <td className="desc">{item.status}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>


        </div>

      </div> */}

      <div className='row'>
        <div className='col-lg-6 col-md-6 col-sm-12'>
          <div className='card main-card-dashboard p-3'>

            <b className='text-start mb-3'>Project Reports <span className='current-year'>current year</span></b>
            <Bar data={barChartData} options={barChartOptions} />
          </div>


        </div>
        <div className='col-lg-6 col-md-6 col-sm-12'>
          <div className='card main-card-dashboard p-3'>
            <div className=' d-flex justify-content-between'>
              <b className='text-start mb-3'>Income Reports <span className='current-year'>current year</span></b>
              <button
                onClick={handleShowIncomeReport}
                className={`buttonswitch btn btn-secondary  ${activeChart === 'incomeReports' ? 'active1' : ''}`}
              >
                INR Income
              </button>
              <button
                onClick={handleShowDollarChart}
                className={`buttonswitch btn btn-secondary  ${activeChart === 'dollarChart' ? 'active2' : ''}`}
              >
                Dollar Income
              </button>
            </div>



            {activeChart === 'incomeReports' && <Line {...lineChartConfig} />}
            {activeChart === 'dollarChart' && <Line {...lineChartConfigdollar} />}


          </div>
        </div>
      </div>
    </>
  )
}

export default Dashboard;